import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    records: [],
    totalCount: 0,
    pagination: {
      page: 1,
      size: 25
    }
  },
  getters: {},
  mutations: {
    setRecords(state, payload) {
      state.records = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    getRecords({ commit }, query) {
      api.getRecords(query).then(({ data }) => {
        commit('setRecords', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    setcalculate(context, data) {
      return api.setcalculate(data);
    },
    sendAmount(context, data) {
      return api.sendAmount(data);
    }
  }
};

appStore.registerModule('miningbonus', store);
